import { memo, useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { createChildAppOnNavigate } from 'modules/app-registry/utils'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'

export const ExternalFormsApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()
    // Window mode emits basename-stripped paths (`/workspaces`); prefix them
    // with the app path so the container doesn't leave `/external-forms`.
    const onNavigate = useMemo(
      () => createChildAppOnNavigate(apps[AppId.EXTERNAL_FORMS].path, navigate),
      [apps, navigate]
    )

    return (
      <FullPageAppTemplate
        appId={AppId.EXTERNAL_FORMS}
        scope='external_forms'
        envKey={apps[AppId.EXTERNAL_FORMS].runtimeEnvKey}
        entryPath='./ExternalFormsApp'
        url={process.env.REACT_APP_EXTERNAL_FORMS_APP_DEV_PATH}
        appName={apps[AppId.EXTERNAL_FORMS].name}
        appProps={{
          user,
          history: history,
          appPath: apps[AppId.EXTERNAL_FORMS].path,
          initialPath: location.pathname,
          onNavigate
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)
